import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "../lib/config";
import { useAuth } from "../contexts/AuthContext";
import { Loader2, XCircle } from "lucide-react";
import Logo from "../components/Logo";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const { setUser } = useAuth();
  const [error, setError] = useState(null);
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;

    const code = params.get("code");
    const state = params.get("state");
    const err = params.get("error");

    if (err) {
      setError(err);
      setTimeout(() => navigate("/login?error=" + encodeURIComponent(err), { replace: true }), 1500);
      return;
    }
    if (!code) {
      navigate("/login", { replace: true });
      return;
    }

    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirect_uri =
      sessionStorage.getItem("google_oauth_redirect_uri") ||
      window.location.origin + "/auth/google";
    const next = sessionStorage.getItem("google_oauth_next") || "/dashboard";

    (async () => {
      try {
        const { data } = await api.post(
          "/auth/google/callback",
          { code, redirect_uri },
          { params: state ? { state } : {} }
        );
        sessionStorage.removeItem("google_oauth_redirect_uri");
        sessionStorage.removeItem("google_oauth_next");
        if (data?.user) setUser(data.user);
        const target = data?.user?.is_admin ? "/admin" : next;
        navigate(target, { replace: true });
      } catch (e) {
        setError(e?.response?.data?.detail || "Google sign-in failed");
        setTimeout(() => navigate("/login?error=google", { replace: true }), 1800);
      }
    })();
  }, [params, navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F4F6F5] px-4" data-testid="auth-callback-loading">
      <div className="bg-white rounded-3xl border border-gray-200 px-8 py-10 text-center shadow-sm max-w-sm w-full">
        <div className="flex justify-center mb-5">
          <Logo size={56} />
        </div>
        {error ? (
          <>
            <XCircle className="w-10 h-10 text-red-500 mx-auto" />
            <h1 className="mt-4 text-lg font-extrabold text-gray-900 font-[Outfit]">Sign-in failed</h1>
            <p className="mt-1 text-sm text-gray-600">{String(error)}</p>
          </>
        ) : (
          <>
            <Loader2 className="w-10 h-10 animate-spin text-[#10B981] mx-auto" />
            <h1 className="mt-4 text-lg font-extrabold text-gray-900 font-[Outfit]">Signing you in…</h1>
            <p className="mt-1 text-sm text-gray-600">Securely connecting your Google account.</p>
          </>
        )}
      </div>
    </div>
  );
}
